module.exports = __webpack_public_path__ + "static/arct-maint-logo-2bd0acb3eeee321ab464e9605a9f366b.jpeg";